import React, { useEffect, useState } from 'react';
import MaterialIcon from 'material-icons-react';

import {
  Label,
  Button,
  AicsaLogo,
  ButtonLabel,
  EmptyTitle,
  FlexBetween,
  TokenContain,
  ProviderName,
  FormsliveLogo,
  EmptyContain,
  ListItemContain,
  ProviderSubText
  } from './Styled';
import Dialog from 'components/Dialog';
import TextInput from 'components/TextInput';
import RadioButton from 'components/RadioButton';
import ErrorDisplay from 'components/ErrorDisplay';
import ErrorInput from 'components/ErrorInput';

const useConnectDialog = ({ onSubmit }) => {
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({});

  useEffect(function clearState () {
    if (!open) {
      setState({});
    }
  }, [ open ])

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (name, value) => setState(s => ({ ...s, [name]: value }))

  const handleSubmit = () => {
    onSubmit(state);
  };

  const renderDialog = (loading, error, inputErrors) => (
    <Dialog
      open={open}
      loading={loading}
      hideCancel
      showFloatingCancel
      onSubmit={handleSubmit}
      onClose={handleClose}
      submitLabel="Connect"
      title="Connect Provider"
      subTitle={loading ? "" : "Select a provider and enter the third party access token to get started."}
    >
      <div style={{ marginTop: '1em' }}>
        <Label>Connect</Label>
        <ErrorInput errorText={inputErrors.type} marginBottom={0.5} />
        <FlexBetween>
          <div style={{ flex: 1 }}>
            <FormsliveLogo />
            <RadioButton 
              value='rei' 
              label="Forms Live"
              checked={state.type === 'rei'} 
              onClick={handleChange.bind(null, 'type')} 
            />
          </div>
          <div style={{ flex: 1 }}>
            <AicsaLogo />
            <RadioButton
              value='aic'
              label="AIC" 
              checked={state.type === 'aic'}
              onClick={handleChange.bind(null, 'type')}
            />
          </div>
        </FlexBetween>
      </div>
      <TokenContain>
        <TextInput
          bold
          fullWidth
          name={'token'}
          value={state.token}
          onChange={handleChange}
          label={'Token'}
          errorText={inputErrors.token}
          placeholder={'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'}
        />
      </TokenContain>

      {!loading && <ErrorDisplay message={error} />}
    </Dialog>
  );

  return [ renderDialog, handleOpen, handleClose ];
};

const EmptyState = ({ onConnect }) => {
  return (
    <EmptyContain>
      <EmptyTitle>Connect Third Party</EmptyTitle>
      <p style={{marginTop: 0 }}>Connect a third party provider to allow access to your account</p>

      <Button onClick={onConnect}>
        <ButtonLabel>Connect</ButtonLabel>
      </Button>
    </EmptyContain>
  )
};

const ProviderListItem = ({ avatar: Avatar, name, onDisconnect }) => {
  return (
    <ListItemContain>
      <FlexBetween>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Avatar />
   
          <div style={{ marginLeft: '1em' }}>
            <ProviderName>{name}</ProviderName>
            <ProviderSubText>{name} is currently connected</ProviderSubText>
          </div>
        </div>
        <div>
          <Button secondary onClick={onDisconnect}>
            <div style={{ position: 'relative', top: '6px' }}><MaterialIcon icon="remove_circle_outline" color={'rgb(20, 76, 110)'} size={24} /></div>
            <ButtonLabel>Disconnect</ButtonLabel>
          </Button>
        </div>
      </FlexBetween>
    </ListItemContain>
  )
}

export {
  EmptyState,
  useConnectDialog,
  ProviderListItem
};
